'use client';

import React from 'react';
import { Alert, AlertTitle, Stack, Typography } from '@unity/cloud-ui';

export interface AdmonitionProps {
  title: string;
  severity: 'info' | 'success' | 'warning' | 'error';
}

export const Admonition = (props: React.PropsWithChildren<AdmonitionProps>) => {
  const { title, severity, children } = props;

  const noStringChildren = React.Children.toArray(children).every((child) => typeof child !== 'string');

  return (
    <Alert
      severity={severity}
      slotProps={{
        icon: { 'aria-hidden': true },
      }}
    >
      <AlertTitle>{title}</AlertTitle>
      <Typography component="span">{noStringChildren ? <Stack gap={1}>{children}</Stack> : children}</Typography>
    </Alert>
  );
};
